var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{on:{"click":_vm.post}},[_vm._v("SOOQA")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }